export default "__VITE_ASSET__L3Ou2BXB__"